import React, { useMemo } from 'react';

const WEAK_PASSWORDS = ['password', '12345678', 'qwerty123', 'admin123', 'letmein', 'welcome1'];

export function evaluatePassword(pw) {
  const checks = {
    length: pw.length >= 8,
    upper: /[A-Z]/.test(pw),
    lower: /[a-z]/.test(pw),
    digit: /\d/.test(pw),
    notWeak: pw && !WEAK_PASSWORDS.includes(pw.toLowerCase()),
    notTooLong: pw.length <= 128,
  };
  const passed = Object.values(checks).filter(Boolean).length;
  const total = Object.keys(checks).length;
  const valid = passed === total && pw.length > 0;
  let strength = 'weak';
  if (passed >= 5) strength = 'strong';
  else if (passed >= 4) strength = 'medium';
  return { valid, checks, passed, total, strength };
}

export default function PasswordStrength({ password }) {
  const result = useMemo(() => evaluatePassword(password || ''), [password]);
  if (!password) return null;

  const colors = {
    weak: 'var(--danger, #ef4444)',
    medium: 'var(--warn, #d9a23a)',
    strong: 'var(--good, #10b981)',
  };
  const labels = {
    weak: 'Zayıf',
    medium: 'Orta',
    strong: 'Güçlü',
  };
  const fillPct = Math.round((result.passed / result.total) * 100);

  return (
    <div style={{ marginTop: 6 }}>
      <div style={{
        height: 4,
        background: 'var(--surface-muted)',
        borderRadius: 2,
        overflow: 'hidden',
      }}>
        <div style={{
          width: `${fillPct}%`,
          height: '100%',
          background: colors[result.strength],
          transition: 'width .2s, background .2s',
        }} />
      </div>
      <div style={{
        marginTop: 6,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        fontSize: 11,
        color: 'var(--text-muted)',
      }}>
        <span>
          {result.checks.length ? '✓' : '✗'} 8+ karakter ·{' '}
          {result.checks.upper ? '✓' : '✗'} büyük ·{' '}
          {result.checks.lower ? '✓' : '✗'} küçük ·{' '}
          {result.checks.digit ? '✓' : '✗'} rakam
        </span>
        <span style={{ color: colors[result.strength], fontWeight: 600 }}>
          {labels[result.strength]}
        </span>
      </div>
    </div>
  );
}
